import { useCallback } from "react";

const useGoBack = () => useCallback(() => {
    window.history.go(-1);
}, []);

export { useGoBack };
